import { createFileRoute } from "@tanstack/react-router";

import { AdminDemoInviti } from "@/features/admin";

/**
 * Admin · Demo Inviti — manage invites to the client-facing demo
 * (issue/email/link, edit duration, revoke, reactivate, usage).
 */
export const Route = createFileRoute("/_authed/_modal/admin/demo-inviti")({
  component: AdminDemoInviti,
});
